import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ModalProps } from './storage-hard-limit-modal';

const storageHardLimitEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		ModalProps,
		Record<string, never>
	>,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-storage-hard-limit-modal" */ './storage-hard-limit-modal'
			),
		{
			moduleId: 'edition-awareness-storage-hard-limit-modal',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});

export default storageHardLimitEntryPoint;
